export const PerguntasFrequentes = {
  "365artes": [
    "Os banners ficam salvos na minha conta do Canva?",
    "Como posso adicionar selos especiais no aplicativo 365Artes?",
    "Como faço para criar minha conta no 365Artes?",
  ],
  automagico: [
    "Como posso importar produtos em massa usando o Automagico?",
    "Como faço para garantir que os SKUs estejam cadastrados corretamente antes de importar produtos?",
    "Como posso importar produtos em massa com o aplicativo?",
  ],
  campopersonalizado: [
    "Como posso adicionar um Campo Personalizado no meu aplicativo?",
    "Como posso personalizar as características do produto?",
    "Por que os campos de seleção estão invisíveis?",
  ],
  cheguei: [
    'Como faço para instalar o botão "Avise-me quando chegar" na minha loja Shopify?',
    "Como faço para exportar os relatórios do app?",
    "Como faço para criar minha conta no Cheguei?",
  ],
  dijital: [
    "É possível desativar o envio de produtos por e-mail no Dijital?",
    "Como posso renovar minha assinatura para resolver o erro 401?",
    "Como posso contatar o suporte?",
  ],
  dropi: [
    "Posso importar produtos de fornecedores nacionais no plano gratuito do Dropi?",
    "Como posso filtrar produtos de um fornecedor específico?",
    "Qual plano é melhor para quem está começando no mercado?",
  ],
  fretehero: [
    "Como configuro o prazo de pré-venda no aplicativo?",
    "Como posso entrar em contato com o suporte?",
    "Como faço para criar minha conta no Frete Hero Plus?",
  ],
  landingpage: [
    "Como posso criar uma página de vendas com o aplicativo?",
    "Posso hospedar páginas externas na plataforma Landinpage?",
    "Como posso vincular um domínio à minha página?",
  ],
  lilyreviews: [
    "Como posso importar avaliações do AliExpress para o Dropi?",
    "É possível importar avaliações de um produto descontinuado?",
    "Como eu posso personalizar o email que envio aos meus clientes?",
  ],
  suporteovni: [
    "Como criar uma campanha?",
    "Como encontrar influenciadores?",
    "Como me cadastrar no ovni como influenciador?",
  ],
  parcelamento: [
    "Como funciona o aplicativo de parcelamento?",
    "O aplicativo de parcelamento afeta as variantes dos produtos no carrinho?",
    "Como posso solicitar a instalação de um tema que não encontrei no aplicativo?",
  ],
  rastreio: [
    "Como posso adicionar o logo da minha marca nas mensagens?",
    "Por que só um dos meus pedidos está aparecendo no app?",
    "Como faço para integrar o Rastreio à Yampi?",
  ],
  suporte: [
    "Como posso acessar meus rascunhos de mensagens?",
    "Os links estáticos não contabilizam cliques?",
    "Como eu posso mudar o ícone do botão SAK?",
  ],
  widget: ["Como faço para criar minha conta no Widget?"],
  "lily-latam": [
    "¿Puedo usar emojis en mis comentarios?",
    "¿Cómo puedo importar calificaciones con Excel?",
    "¿Puedo cambiar la posición de las estrellas en mi sitio web?",
  ],
  "automagico-latam": [
    "¿Cómo puedo suscribirme a un plan de Automático?",
    "¿Dónde puedo ver los productos que he exportado en Automágico?",
    "¿Cuáles son los beneficios de cada plan?",
  ],
  "llegue-latam": [
    "¿Puedo probar el plan de Cheguei antes de suscribirme?",
    "¿Cómo puedo programar una videollamada para soporte?",
    "¿Cómo contacto al soporte?",
  ],
  "dijital-latam": [
    "¿Cómo puedo adjuntar archivos a mis productos?",
    "¿Cuáles son los beneficios del PLAN BÁSICO?",
    "¿Cómo puedo programar una videollamada para soporte?",
  ],
  dropimx: [
    "¿Por qué aparece el error #722 al hacer mi pedido?",
    "¿Por qué mi pedido no aparece en Dropi después de ser aprobado?",
    "¿Puedo procesar un pedido de Aliexpress en FForder?",
  ],
  "campopersonalizado-latam": [
    "¿Cuáles son los beneficios del plan de suscripción?",
    "¿Cómo puedo agregar campos personalizables a mis productos?",
    "¿Cómo puedo verificar los detalles de un pedido en el panel?",
  ],
  "landingpage-latam": [
    "¿Cómo creo un kit de productos en mi LandingPage?",
    "¿Es necesario tener un plan de pago para integrar LandingPage con Tiendanube?",
    "¿Cómo puedo empezar a crear mi página web con la aplicación?",
  ],
  plus: [
    "Como posso contatar o suporte da Empreender?",
    "Como posso mudar meu plano para o Básico?",
    "Quais plataformas posso conectar ao aplicativo que escolhi?",
  ],
  botaozap: [
    "Como posso usar o botão Zap para falar com você?",
    "Como faço para integrar o Botão Zap à minha loja Shopify?",
    "Qual é o valor do plano de assinatura?",
  ],
  "plus-latam": [
    "¿Cómo contacto al soporte?",
    "¿Cuál es el descuento para el pago anual?",
    "¿Puedo probar la aplicación gratis durante 3 días?",
  ],
  whatsly: [
    "Como faço para integrar o Whatsly à Nuvemshop?",
    "Como posso assinar um plano do Whats.Ly?",
    "Como posso adicionar membros na minha equipe no Whats.Ly?",
  ],
  soporte: [
    "¿Puedo solicitar un reembolso si pagué mi plan dos veces por accidente?",
    "¿Cómo puedo cambiar mi correo electrónico en mi cuenta?",
    "¿Cómo puedo contactar al soporte?",
  ],
  replay: [
    "Como o Replay pode ajudar a aumentar minhas vendas?",
    "O que são as bolinhas interativas no vídeo commerce?",
    "Posso cancelar minha assinatura a qualquer momento?",
  ],
  supercheckout: [
    "Como faço para integrar o Super Checkout à Nuvemshop?",
    "Como eu adiciono selos personalizados no meu checkout?",
    "Como eu aplico o cupom de trial?",
  ],
  superfavoritos: [
    "Como posso personalizar o botão de favoritos na minha loja virtual?",
    "Como posso entrar em contato com o suporte?",
    "Como posso adicionar um cupom de trial na minha conta?",
  ],
  promocaoagendada: [
    "Como posso agendar uma promoção na minha loja?",
    "Como posso entrar em contato com o suporte?",
    "Como faço para criar minha conta na Promoção Agendada?",
  ],
  dropdigital: [
    "Como posso vender cursos online no drop.digital?",
    "Como posso criar um curso na plataforma?",
    "Quantos produtos estão disponíveis no aplicativo?",
  ],
  selly: [
    "Como posso configurar a funcionalidade Roleta no Selly?",
    "Como posso ativar as ferramentas na página de início?",
    "Como posso ativar o controle de estoque na minha loja Nuvemshop?",
  ],
  feedxml: [
    "Como posso instalar o app Feed XML na minha loja Nuvemshop?",
    "Quais são os benefícios do Plano Essencial do FeedXML?",
    "Como posso instalar o aplicativo FeedXML?",
  ],
  "feedxml-latam": [
    "¿Dónde puedo encontrar la aplicación FeedXML?",
    "¿Cómo puedo instalar la aplicación Feed XML en mi tienda Tiendanube?",
  ],
  embaixadores: [
    "Onde encontro os links de divulgação?",
    'O que significa "Trial" no aplicativo dos Embaixadores?',
    "Qual é a diferença entre o link da LandingPage e o link da página de cadastro?",
  ],
  appdashboard: [
    "O que é o Dash?",
    "Como inserir gráficos?",
    "Quais os planos e preços do Dash?",
  ],
  areadocliente: [
    "Quais são os planos e preços do Área do Cliente?",
    "Como integrar o Área do Cliente com a Nuvemshop?",
  ],
  descricaopro: [
    "Como posso adicionar uma descrição ao meu produto?",
    "Com quais plataformas o Descrição Pro faz integração?",
    "Quais são os planos e preços do Descrição Pro?",
  ],
  montink: [
    "Como alterar ou cancelar um pedido na Montink?",
    "Qual o Fluxo de um pedido dentro da Montink?",
    "Como é emitida a Nota Fiscal de um pedido?",
  ],
  suportebuybutton: [
    "Quais são os planos e valores do Buy Button?",
    "Como adicionar uma coleção com o Buy Button no meu site?",
    "O que é o Buybutton?",
  ],
  suporteshowtime: [
    "Posso usar qualquer música?",
    "Como instalar o aplicativo na minha loja?",
    "Onde o player aparece na loja?",
  ],
};
